import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

function ContactForm({ formData, errors, submitting, onChange, onProjectTypeChange, onSubmit }) {
  return (
    <div className="lg:col-span-2">
      <form onSubmit={onSubmit} className="bg-white rounded-lg shadow-xl shadow-stone-200/50 p-8">
        <h2 className="text-2xl font-bold text-slate-900 mb-2">Send Us a Message</h2>
        <p className="text-stone-600 mb-6 text-sm">Your message will be sent directly to our WhatsApp</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <Label htmlFor="name" className="text-slate-900 font-medium">
              Full Name <span className="text-red-500">*</span>
            </Label>
            <Input
              id="name"
              name="name"
              value={formData.name}
              onChange={onChange}
              placeholder="John Smith"
              className={`mt-2 h-12 ${errors.name ? 'border-red-500' : ''}`}
              data-testid="contact-name-input"
            />
            {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
          </div>

          <div>
            <Label htmlFor="phone" className="text-slate-900 font-medium">
              Phone Number <span className="text-red-500">*</span>
            </Label>
            <Input
              id="phone"
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={onChange}
              placeholder="07123 456789"
              className={`mt-2 h-12 ${errors.phone ? 'border-red-500' : ''}`}
              data-testid="contact-phone-input"
            />
            {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
          </div>

          <div>
            <Label htmlFor="address" className="text-slate-900 font-medium">
              Location (Optional)
            </Label>
            <Input
              id="address"
              name="address"
              value={formData.address}
              onChange={onChange}
              placeholder="Town/Area"
              className="mt-2 h-12"
              data-testid="contact-address-input"
            />
          </div>

          <div>
            <Label htmlFor="projectType" className="text-slate-900 font-medium">
              Project Type (Optional)
            </Label>
            <Select value={formData.projectType} onValueChange={onProjectTypeChange}>
              <SelectTrigger className="mt-2 h-12" data-testid="contact-project-type-select">
                <SelectValue placeholder="Select a project type" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="loft_conversion">Loft Conversion</SelectItem>
                <SelectItem value="house_extension">House Extension</SelectItem>
                <SelectItem value="kitchen_renovation">Kitchen Renovation</SelectItem>
                <SelectItem value="bathroom">Bathroom Renovation</SelectItem>
                <SelectItem value="fitted_wardrobes">Fitted Wardrobes</SelectItem>
                <SelectItem value="full_refurbishment">Full Refurbishment</SelectItem>
                <SelectItem value="other">Other</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="mb-6">
          <Label htmlFor="message" className="text-slate-900 font-medium">
            Your Message <span className="text-red-500">*</span>
          </Label>
          <Textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={onChange}
            placeholder="Tell us about your project - size, timeline, any specific requirements..."
            className={`mt-2 min-h-[150px] ${errors.message ? 'border-red-500' : ''}`}
            data-testid="contact-message-input"
          />
          {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
        </div>

        <WhatsAppButton submitting={submitting} data-testid="contact-submit-button">
          Send via WhatsApp
        </WhatsAppButton>
      </form>
    </div>
  );
}

export default ContactForm;
